import * as common from './common.json';

export const es = {
  common,
};
